import { getCurrentInstance } from 'vue-demi'

export default function useGoToPageWithQueries() {
  const instance = getCurrentInstance()

  if (!instance) {
    throw new Error(
      'useRedirect() doit être utilisé dans un setup() ou une fonction de lifecycle.',
    )
  }

  const router = (instance.proxy as any).$router
  const route = (instance.proxy as any).$route

  async function push(name, query = {}, replace = false) {
    if (!router || !route) {
      return
    }

    const mode = replace ? 'replace' : 'push'

    const preservedQuery = {
      editingMode: route.query.editingMode || false,
      petStatus: route.query.petStatus,
      code_promo: route.query.code_promo,
      customerId: route.query.customerId,
      standardisation: route.query.standardisation,
      petId: route.query.petId,
      petIndex: route.query.petIndex >= 0 ? route.query.petIndex : undefined,
      context: route.query.context,
      redirectUrl: route.query.redirectUrl,
    }

    const filteredQuery = Object.fromEntries(
      Object.entries({ ...preservedQuery, ...query }).filter((value) => {
        const [_, v] = value

        return v !== undefined
      }),
    )

    await router[mode]({ name, query: filteredQuery })
  }

  return { push }
}
